import { render, staticRenderFns } from "./TabelaEfetuadas.vue?vue&type=template&id=17a8db14&scoped=true"
import script from "./TabelaEfetuadas.vue?vue&type=script&lang=js"
export * from "./TabelaEfetuadas.vue?vue&type=script&lang=js"
import style0 from "./TabelaEfetuadas.vue?vue&type=style&index=0&id=17a8db14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a8db14",
  null
  
)

export default component.exports